
export const Type = {
  OPEN_EDITOR: "JSME_OPEN_EDITOR",
  CLOSE_EDITOR: "JSME_CLOSE_EDITOR",
};

export const openEditor = (smiles, onConfirm, position) => ({ type: Type.OPEN_EDITOR, smiles, onConfirm, position });

export const closeEditor = () => ({ type: Type.CLOSE_EDITOR });
